import React, {useEffect, useState} from 'react'

function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}


const SetRatingStars = ({initialRate, getRate}) => {
    const [activeStars, setActiveStars] = useState(initialRate)

    function clickStar(value) {
        getRate(value);
        setActiveStars(value)
    }

    useEffect(() => {
        setActiveStars(initialRate)
    }, [initialRate]);


    return (
        <>
            {
                [...Array(5)].map((_, i) => {
                    const ratingValue = i + 1
                    return (
                        <label key={i}>
                            <input type="radio" name="rating" value={ratingValue} onClick={() => clickStar(ratingValue)} style={{display: 'none'}}/>
                            <img
                                src={`/images/icon/${ratingValue <= activeStars ? 100 : 0}.svg`}
                                alt="star"
                                {...(isTouchDevice() ? {
                                        // onClick() { setHover(ratingValue) },
                                    } : {
                                        onMouseEnter() {
                                            setActiveStars(ratingValue)
                                        },
                                        onMouseLeave() {
                                            setActiveStars(initialRate)
                                        },
                                    }
                                )}
                            />
                        </label>
                    )
                })
            }
        </>
    )
}

export default SetRatingStars
